import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { BaseService } from '../../helpers/base.service';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import {
  ControlledSubstanceLogViewModel,
  ControlledSubstanceLogPage,
  ControlledSubstanceLog,
  ControlledSubstanceLogV2ListViewModel,
  ControlledSubstanceLogV2Page,
  ControlledSubstanceLogV2History
} from '../models/controlled-substance-logs.models';


@Injectable({
  providedIn: 'root',
})
export class ControlledSubstanceLogsService extends BaseService {


  public index(page: ControlledSubstanceLogPage): Observable<ControlledSubstanceLogViewModel> {
    const route = `${this.apiUrl}/ControlledSubstanceLog`;
    const body = JSON.stringify(page);
    return this.http.post<ControlledSubstanceLogViewModel>(route, body, this.headers()).pipe(map(response => {
      return response;
    }));
  }

  public indexV2(page: ControlledSubstanceLogV2Page): Observable<ControlledSubstanceLogV2ListViewModel> {
    const route = `${this.apiUrl}/ControlledSubstanceLogV2`;
    
    let params = new HttpParams()
      .set('pageNumber', page.pageNumber.toString())
      .set('size', page.size.toString());
    
    // Add optional query parameters if they exist
    if (page.userId) {
      params = params.set('patientId', page.userId);
    }
    
    if (page.searchFilter && page.searchFilter.trim()) {
      params = params.set('searchFilter', page.searchFilter.trim());
    }
    
    return this.http.get<ControlledSubstanceLogV2ListViewModel>(route, { ...this.headers(), params }).pipe(map(response => {
      return response;
    }));
  }

  public create(model: ControlledSubstanceLog, patientId: string): Observable<any> {
    const route = `${this.apiUrl}/ControlledSubstanceLog/${patientId}`;
    const body = JSON.stringify(model);
    return this.http.post<any>(route, body, this.headers()).pipe(map(response => {
      return response;
    }));
  }

  public getLogHistory(logId: string): Observable<ControlledSubstanceLogV2History[]> {
    const route = `${this.apiUrl}/ControlledSubstanceLogV2/${logId}`;
    return this.http.get<ControlledSubstanceLogV2History[]>(route, this.headers()).pipe(map(response => {
      return response;
    }));
  }

}
